import { render, staticRenderFns } from "./RemoveTechnicalParameterComponent.vue?vue&type=template&id=29b1e7c3&scoped=true&"
import script from "./RemoveTechnicalParameterComponent.vue?vue&type=script&lang=js&"
export * from "./RemoveTechnicalParameterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b1e7c3",
  null
  
)

export default component.exports